import { UsPgaFlag } from '__generated__/graphql';

export * from './getCustomProductLabel';
export * from './getRealTariffIndex';
export * from './handleCompletedProductEmbeddingFields';
export * from './handleSetProductQuantity';
export * from './mapEmbeddedProductFields';
export * from './nestSupplierOrFacilityFields';
export * from './resolveNetWeightSync';
export * from './setAssistFromPercentage';
export * from './setProductUnitQuantity';
export * from './setProductUnitValueField';
export * from './setSupplierOrFacilityVersion';
export * from './types';

export const US_PGA_FLAGS_SUBJECT_TO_APHIS_CORE = [
  UsPgaFlag.AQ1,
  UsPgaFlag.AQ2,
];
